import { v4 as uuidv4 } from 'uuid';
import VideoPlayer from '../../../shared/video-player/video-player';
import Quiz from './body/Quiz';
import Introduction from './pages/mod-1/Introduction';
import ModObjectives from './pages/mod-1/ModObjectives';
import CoreCompoenents from './pages/mod-1/CoreCompoenents';
import Overview from './pages/mod-1/Overview';
import Mod1Quiz from './pages/mod-1/Mod1Quiz';
import { default as Mod1Intro } from './pages/mod-2/Introduction';
import ChildCenteredTime from './pages/mod-2/ChildCenteredTime';
import DescriptiveCommenting from './pages/mod-2/DescriptiveCommenting';
import FamilyRoutinesVideo from './pages/mod-2/FamilyRoutinesVideo';
import FamilyRoutinesActivity from './pages/mod-2/FamilyRoutinesActivity';
import ReadingAsRoutine from './pages/mod-2/ReadingAsRoutine';
import BehaviorAgain from './pages/mod-2/BehaviorAgain';
import LabeledPraise from './pages/mod-2/LabeledPraise';
import LabeledPraiseActivity from './pages/mod-2/LabeledPraiseActivity';
import RewardsActivity from './pages/mod-2/RewardsActivity';
import RewardProgram from './pages/mod-2/RewardProgram';
import SayWhatYouMean from './pages/mod-2/SayWhatYouMean';
import HouseholdRules from './pages/mod-2/HouseholdRules';
import DoStatements from './pages/mod-2/DoStatements';
import DoStatementsActivity from './pages/mod-2/DoStatementsActivity';
import WarningStatements from './pages/mod-2/WarningStatements';
import FollowingThrough from './pages/mod-2/FollowingThrough';
import RewardsVideo from './pages/mod-2/RewardsVideo';
import Mod2Quiz from './pages/mod-2/Mod2Quiz';
import Mod3Intro from './pages/mod-3/Introdution';
import NaturalIfThen from './pages/mod-3/NaturalIfThen';
import LogicalIfThen from './pages/mod-3/LogicalIfThen';
import LogicalIfThenActivity from './pages/mod-3/LogicalIfThenActivity';
import WhenThenStatements from './pages/mod-3/WhenThenStatements';
import NoAttentionForBehavior from './pages/mod-3/NoAttentionForBehavior';
import Ignoring from './pages/mod-3/Ignoring';
import EightKeysToEffectiveDiscipline from './pages/mod-3/EightKeysToEffectiveDiscipline';
import TimeOut from './pages/mod-3/TimeOut';
import TimeOutOne from './pages/mod-3/TimeOutOne';
import TimeOutTwo from './pages/mod-3/TimeOutTwo';
import TimeOutThree from './pages/mod-3/TimeOutThree';
import StressManagement from './pages/mod-3/StressManagement';
import ReducingStress from './pages/mod-3/ReducingStress';
import ProblemSolving from './pages/mod-3/ProblemSolving';
import Mod3Quiz from './pages/mod-3/Mod3Quiz';
import Distracting from './pages/mod-3/Distracting';
import ReframingActivity from './pages/mod-3/ReframingActivity';
import YouVsIStatementsActivity from './pages/mod-3/YouVsIStatementsActivity';
import IStatments from './pages/mod-3/IStatments';
import HybridIntroduction from './pages/hybrid/Introduction';
import EzParentProgramOverview from './pages/hybrid/EzParentProgramOverview';
import HybridEzParentDelivery from './pages/hybrid/HybridEzParentDelivery';
import GroupFacilitation from './pages/hybrid/GroupFacilitation';
import EzParentHybridGroupFacilitation from './pages/hybrid/EzParentHybridGroupFacilitation';
import HybridQuiz from './pages/hybrid/HybridQuiz';
import HybridCertificate from './pages/hybrid/HybridCertificate';

const fascilitatorTrainingRoutes = [
  {
    title: 'Introduction',
    id: uuidv4(),
    url: 'introduction',
    fullUrl: '/facilitator/introduction',
    subRoutes: [
      {
        id: uuidv4(),
        title: 'Module Objectives ',
        url: 'module-objectives',
        fullUrl: '/facilitator/introduction/module-objectives',
        component: <ModObjectives />,
      },
      {
        id: uuidv4(),
        title: 'INTRODUCTION TO THE CHICAGO PARENT PROGRAM ',
        url: 'introduction-to-the-chicago-parent-program',
        fullUrl:
          '/facilitator/introduction/introduction-to-the-chicago-parent-program',
        component: <Introduction />,
      },
      {
        id: uuidv4(),
        title: 'CHICAGO PARENT PROGRAM OVERVIEW',
        url: 'chicago-parent-program-overview',
        fullUrl: '/facilitator/introduction/chicago-parent-program-overview',
        component: <Overview />,
      },
      {
        id: uuidv4(),
        title: 'CORE COMPONENTS',
        url: 'core-components',
        fullUrl: '/facilitator/introduction/core-components',
        component: <CoreCompoenents />,
      },
      {
        id: uuidv4(),
        title: 'Quiz',
        url: 'quiz',
        fullUrl: '/facilitator/introduction/quiz',
        component: <Mod1Quiz />,
      },
    ],
  },
  {
    title: 'Program Strategies Part 1',
    url: 'strategies-1',
    id: uuidv4(),
    fullUrl: '/facilitator/strategies-1',
    sections: [
      {
        title: 'Introduction',
        url: 'introduction',
        id: uuidv4(),
        fullUrl: '/facilitator/strategies-1/introduction',
        subRoutes: [
          {
            id: uuidv4(),
            title: 'Introduction',
            url: '',
            fullUrl: '/facilitator/strategies-1/introduction',
            component: <Mod1Intro />,
          },
        ],
      },
      {
        title: 'Child-Centered Time and Following the Child’s Lead',
        url: 'child-centered-time',
        id: uuidv4(),
        fullUrl: '/facilitator/strategies-1/child-centered-time',
        subRoutes: [
          {
            id: uuidv4(),
            title: 'Child-Centered Time and Following the Child’s Lead',
            url: '',
            fullUrl: '/facilitator/strategies-1/child-centered-time',
            component: <ChildCenteredTime />,
          },
        ],
      },
      {
        title: 'Descriptive Commenting ',
        url: 'descriptive-commenting',
        id: uuidv4(),
        fullUrl: '/facilitator/strategies-1/descriptive-commenting',
        subRoutes: [
          {
            id: uuidv4(),
            title: 'Descriptive Commenting ',
            url: '',
            fullUrl: '/facilitator/strategies-1/descriptive-commenting',
            component: <DescriptiveCommenting />,
          },
        ],
      },
      {
        title: 'Family Routines & Traditions',
        url: 'family-routines-traditions',
        id: uuidv4(),
        fullUrl: '/facilitator/strategies-1/family-routines-traditions',
        subRoutes: [
          {
            id: uuidv4(),
            title: 'Family Routines & Traditions',
            url: 'video',
            fullUrl:
              '/facilitator/strategies-1/family-routines-traditions/video',
            component: <FamilyRoutinesVideo />,
          },
        ],
      },
      {
        title: 'Reading as a Routine',
        url: 'reading-as-routine',
        id: uuidv4(),
        fullUrl: '/facilitator/strategies-1/reading-as-routine',
        subRoutes: [
          {
            id: uuidv4(),
            title: 'Reading as a Routine',
            url: '',
            fullUrl: '/facilitator/strategies-1/reading-as-routine',
            component: <ReadingAsRoutine />,
          },
        ],
      },
      {
        title: 'If You Want To See A Behavior Again',
        url: 'behavior-again',
        id: uuidv4(),
        fullUrl: '/facilitator/strategies-1/behavior-again',
        subRoutes: [
          {
            id: uuidv4(),
            title:
              'If you want to see a behavior again, give it your attention',
            url: '',
            fullUrl: '/facilitator/strategies-1/behavior-again',
            component: <BehaviorAgain />,
          },
        ],
      },
      {
        title: 'Labeled Praise',
        url: 'labeled-praise',
        id: uuidv4(),
        fullUrl: '/facilitator/strategies-1/labeled-praise',
        subRoutes: [
          {
            id: uuidv4(),
            title: 'Labeled Praise',
            url: 'video',
            fullUrl: '/facilitator/strategies-1/labeled-praise/video',
            component: <LabeledPraise />,
          },
          {
            id: uuidv4(),
            title: 'Labeled versus Unlabeled Praise',
            url: 'activity',
            fullUrl: '/facilitator/strategies-1/labeled-praise/activity',
            component: <LabeledPraiseActivity />,
          },
        ],
      },
      {
        title: 'Rewards',
        url: 'rewards',
        id: uuidv4(),
        fullUrl: '/facilitator/strategies-1/rewards',
        subRoutes: [
          {
            id: uuidv4(),
            title: 'Rewards & Bribes',
            url: 'video',
            fullUrl: '/facilitator/strategies-1/rewards/video',
            component: <RewardsVideo />,
          },
          {
            id: uuidv4(),
            title: 'Rewards & Bribes Activity',
            url: 'activity',
            fullUrl: '/facilitator/strategies-1/rewards/activity',
            component: <RewardsActivity />,
          },
        ],
      },
      {
        title: 'Reward Programs',
        url: 'reward-programs',
        id: uuidv4(),
        fullUrl: '/facilitator/strategies-1/reward-programs',
        subRoutes: [
          {
            id: uuidv4(),
            title: 'Reward Programs',
            url: '',
            fullUrl: '/facilitator/strategies-1/reward-programs',
            component: <RewardProgram />,
          },
        ],
      },
      {
        title: 'Say What You Mean and Mean What You Say',
        url: 'say-what-you-mean',
        id: uuidv4(),
        fullUrl: '/facilitator/strategies-1/say-what-you-mean',
        subRoutes: [
          {
            id: uuidv4(),
            title: 'Say What You Mean and Mean What You Say',
            url: '',
            fullUrl: '/facilitator/strategies-1/say-what-you-mean',
            component: <SayWhatYouMean />,
          },
        ],
      },
      {
        title: 'Household Rules',
        url: 'household-rules',
        id: uuidv4(),
        fullUrl: '/facilitator/strategies-1/household-rules',
        subRoutes: [
          {
            id: uuidv4(),
            title: 'Household Rules',
            url: '',
            fullUrl: '/facilitator/strategies-1/household-rules',
            component: <HouseholdRules />,
          },
        ],
      },
      {
        title: (
          <p>
            <span className='italic'>DO</span> Statements
          </p>
        ),
        url: 'do-statements',
        id: uuidv4(),
        fullUrl: '/facilitator/strategies-1/do-statements',
        subRoutes: [
          {
            id: uuidv4(),
            title: 'Do Statements',
            url: 'video',
            fullUrl: '/facilitator/strategies-1/do-statements/video',
            component: <DoStatements />,
          },
          {
            id: uuidv4(),
            title: 'Do Statements Activity',
            url: 'activity',
            fullUrl: '/facilitator/strategies-1/do-statements/activity',
            component: <DoStatementsActivity />,
          },
        ],
      },
      {
        title: 'Warning Statements ',
        url: 'warning-statements',
        id: uuidv4(),
        fullUrl: '/facilitator/strategies-1/warning-statements',
        subRoutes: [
          {
            id: uuidv4(),
            title: 'Warning Statements',
            url: '',
            fullUrl: '/facilitator/strategies-1/warning-statements',
            component: <WarningStatements />,
          },
        ],
      },
      {
        title: 'Following Through',
        url: 'following-through',
        id: uuidv4(),
        fullUrl: '/facilitator/strategies-1/following-through',
        subRoutes: [
          {
            id: uuidv4(),
            title: 'Following Through',
            url: '',
            fullUrl: '/facilitator/strategies-1/following-through',
            component: <FollowingThrough />,
          },
        ],
      },
      {
        title: 'Quiz',
        url: 'quiz',
        id: uuidv4(),
        fullUrl: '/facilitator/strategies-1/quiz',
        subRoutes: [
          {
            id: uuidv4(),
            title: 'Quiz',
            url: '',
            fullUrl: '/facilitator/strategies-1/quiz',
            component: <Mod2Quiz />,
          },
        ],
      },
    ],
  },
  {
    title: 'Program Strategies Part 2',
    url: 'strategies-2',
    id: uuidv4(),
    fullUrl: '/facilitator/strategies-2',
    sections: [
      {
        title: 'Introduction',
        url: 'introduction',
        id: uuidv4(),
        fullUrl: '/facilitator/strategies-2/introduction',
        subRoutes: [
          {
            id: uuidv4(),
            title: 'Introduction',
            url: '',
            fullUrl: '/facilitator/strategies-2/introduction',
            component: <Mod3Intro />,
          },
        ],
      },
      {
        title: 'Natural If/Then Statements',
        url: 'natural-if-then-statements',
        id: uuidv4(),
        fullUrl: '/facilitator/strategies-2/natural-if-then-statements',
        subRoutes: [
          {
            id: uuidv4(),
            title: 'Introduction',
            url: '',
            fullUrl: '/facilitator/strategies-2/natural-if-then-statements',
            component: <NaturalIfThen />,
          },
        ],
      },
      {
        title: 'Logical If/Then Statements',
        url: 'logical-if-then-statements',
        id: uuidv4(),
        fullUrl: '/facilitator/strategies-2/logical-if-then-statements',
        subRoutes: [
          {
            id: uuidv4(),
            title: 'Introduction',
            url: '',
            fullUrl: '/facilitator/strategies-2/logical-if-then-statements',
            component: <LogicalIfThen />,
          },
          {
            id: uuidv4(),
            title: 'Activity',
            url: 'activity',
            fullUrl:
              '/facilitator/strategies-2/logical-if-then-statements/activity',
            component: <LogicalIfThenActivity />,
          },
        ],
      },
      {
        title: 'When/Then Statements',
        url: 'when-then-statements',
        id: uuidv4(),
        fullUrl: '/facilitator/strategies-2/when-then-statements',
        subRoutes: [
          {
            id: uuidv4(),
            title: 'Introduction',
            url: '',
            fullUrl: '/facilitator/strategies-2/when-then-statements',
            component: <WhenThenStatements />,
          },
        ],
      },
      {
        title: 'If you don’t want to see, do not give it your attention',
        url: 'guiding-principles',
        id: uuidv4(),
        fullUrl: '/facilitator/strategies-2/guiding-principles',
        subRoutes: [
          {
            id: uuidv4(),
            title: 'Introduction',
            url: '',
            fullUrl: '/facilitator/strategies-2/guiding-principles',
            component: <NoAttentionForBehavior />,
          },
        ],
      },
      {
        title: 'Ignoring',
        url: 'ignoring',
        id: uuidv4(),
        fullUrl: '/facilitator/strategies-2/ignoring',
        subRoutes: [
          {
            id: uuidv4(),
            title: 'Introduction',
            url: '',
            fullUrl: '/facilitator/strategies-2/ignoring',
            component: <Ignoring />,
          },
        ],
      },
      {
        title: 'Distracting',
        url: 'distracting',
        id: uuidv4(),
        fullUrl: '/facilitator/strategies-2/distracting',
        subRoutes: [
          {
            id: uuidv4(),
            title: 'Introduction',
            url: '',
            fullUrl: '/facilitator/strategies-2/distracting',
            component: <Distracting />,
          },
        ],
      },
      {
        title: '8 Keys to Effective Discipline',
        url: '8-keys-to-effective-discipline',
        id: uuidv4(),
        fullUrl: '/facilitator/strategies-2/8-keys-to-effective-discipline',
        subRoutes: [
          {
            id: uuidv4(),
            title: 'Introduction',
            url: '',
            fullUrl: '/facilitator/strategies-2/8-keys-to-effective-discipline',
            component: <EightKeysToEffectiveDiscipline />,
          },
        ],
      },
      {
        title: 'Time-Outs',
        url: 'time-out',
        id: uuidv4(),
        fullUrl: '/facilitator/strategies-2/time-out',
        subRoutes: [
          {
            id: uuidv4(),
            title: 'Introduction',
            url: '',
            fullUrl: '/facilitator/strategies-2/time-out',
            component: <TimeOut />,
          },
        ],
      },
      {
        title: 'Stress Management',
        url: 'stress-management',
        id: uuidv4(),
        fullUrl: '/facilitator/strategies-2/stress-management',
        subRoutes: [
          {
            id: uuidv4(),
            title: 'Introduction',
            url: '',
            fullUrl: '/facilitator/strategies-2/stress-management',
            component: <StressManagement />,
          },
        ],
      },
      {
        title: 'Reducing Stress',
        url: 'reducing-stress',
        id: uuidv4(),
        fullUrl: '/facilitator/strategies-2/reducing-stress',
        subRoutes: [
          {
            id: uuidv4(),
            title: 'Introduction',
            url: '',
            fullUrl: '/facilitator/strategies-2/reducing-stress',
            component: <ReducingStress />,
          },
          {
            id: uuidv4(),
            title: 'Activity',
            url: 'reframing-activity',
            fullUrl:
              '/facilitator/strategies-2/reducing-stress/reframing-activity',
            component: <ReframingActivity />,
          },
        ],
      },
      {
        title: 'I Statements',
        url: 'i-statements',
        id: uuidv4(),
        fullUrl: '/facilitator/strategies-2/i-statements',
        subRoutes: [
          {
            id: uuidv4(),
            title: 'Introduction',
            url: '',
            fullUrl: '/facilitator/strategies-2/i-statements',
            component: <IStatments />,
          },
          {
            id: uuidv4(),
            title: 'Activity: "You" vs "I" Statements',
            url: 'you-vs-i-statements',
            fullUrl:
              '/facilitator/strategies-2/i-statements/you-vs-i-statements',
            component: <YouVsIStatementsActivity />,
          },
        ],
      },
      {
        title: 'Problem Solving',
        url: 'problem-solving',
        id: uuidv4(),
        fullUrl: '/facilitator/strategies-2/problem-solving',
        subRoutes: [
          {
            id: uuidv4(),
            title: 'Introduction',
            url: '',
            fullUrl: '/facilitator/strategies-2/problem-solving',
            component: <ProblemSolving />,
          },
        ],
      },
      {
        title: 'Quiz',
        url: 'quiz',
        id: uuidv4(),
        fullUrl: '/facilitator/strategies-2/quiz',
        subRoutes: [
          {
            id: uuidv4(),
            title: 'Quiz',
            url: '',
            fullUrl: '/facilitator/strategies-2/quiz',
            component: <Mod3Quiz />,
          },
        ],
      },
    ],
  },
  {
    title: 'Hybrid ezParent Delivery',
    url: 'hybrid-ezparent-delivery',
    id: uuidv4(),
    fullUrl: '/facilitator/hybrid-ezparent-delivery',
    sections: [
      {
        title: 'Introduction',
        url: 'introduction',
        id: uuidv4(),
        fullUrl: '/facilitator/hybrid-ezparent-delivery/introduction',
        subRoutes: [
          {
            id: uuidv4(),
            title: 'Introduction',
            url: '',
            fullUrl: '/facilitator/hybrid-ezparent-delivery/introduction',
            component: <HybridIntroduction />,
          },
        ],
      },
      {
        title: 'ezParent Program Overview',
        url: 'ezparent-program-overview',
        id: uuidv4(),
        fullUrl:
          '/facilitator/hybrid-ezparent-delivery/ezparent-program-overview',
        subRoutes: [
          {
            id: uuidv4(),
            title: 'ezParent Program Overview',
            url: '',
            fullUrl:
              '/facilitator/hybrid-ezparent-delivery/ezparent-program-overview',
            component: <EzParentProgramOverview />,
          },
        ],
      },
      {
        title: 'Hybrid ezParent Delivery',
        url: 'hybrid-delivery',
        id: uuidv4(),
        fullUrl: '/facilitator/hybrid-ezparent-delivery/hybrid-delivery',
        subRoutes: [
          {
            id: uuidv4(),
            title: 'Hybrid ezParent Delivery',
            url: '',
            fullUrl: '/facilitator/hybrid-ezparent-delivery/hybrid-delivery',
            component: <HybridEzParentDelivery />,
          },
        ],
      },
      {
        title: 'Group Facilitation',
        url: 'group-facilitation',
        id: uuidv4(),
        fullUrl: '/facilitator/hybrid-ezparent-delivery/group-facilitation',
        subRoutes: [
          {
            id: uuidv4(),
            title: 'Group Facilitation',
            url: '',
            fullUrl: '/facilitator/hybrid-ezparent-delivery/group-facilitation',
            component: <GroupFacilitation />,
          },
        ],
      },
      {
        title: 'ezParent Hybrid Group Logistics',
        url: 'ezparent-hybrid-group-facilitation',
        id: uuidv4(),
        fullUrl:
          '/facilitator/hybrid-ezparent-delivery/ezparent-hybrid-group-facilitation',
        subRoutes: [
          {
            id: uuidv4(),
            title: 'ezParent Hybrid Group Facilitation',
            url: '',
            fullUrl:
              '/facilitator/hybrid-ezparent-delivery/ezparent-hybrid-group-facilitation',
            component: <EzParentHybridGroupFacilitation />,
          },
        ],
      },
      {
        title: 'Quiz',
        url: 'quiz',
        id: uuidv4(),
        fullUrl: '/facilitator/hybrid-ezparent-delivery/quiz',
        subRoutes: [
          {
            id: uuidv4(),
            title: 'Quiz',
            url: '',
            fullUrl: '/facilitator/hybrid-ezparent-delivery/quiz',
            component: <HybridQuiz />,
          },
        ],
      },
      {
        title: 'Certificate',
        url: 'certificate',
        id: uuidv4(),
        fullUrl: '/facilitator/hybrid-ezparent-delivery/certificate',
        subRoutes: [
          {
            id: uuidv4(),
            title: 'Certificate',
            url: '',
            fullUrl: '/facilitator/hybrid-ezparent-delivery/certificate',
            component: <HybridCertificate />,
          },
        ],
      },
    ],
  },
];

export const flattenRoutes = (routes, parentPath = '', breadcrumbs = []) => {
  const flatRoutes = [];

  routes.forEach((route) => {
    const modulePath = parentPath ? `${parentPath}/${route.url}` : route.url;
    const currentBreadcrumbs = [...breadcrumbs, route.id]; // Use `id` instead of `title`

    if (route.subRoutes) {
      route.subRoutes.forEach((subRoute) => {
        const subRoutePath = subRoute.url
          ? `${modulePath}/${subRoute.url}`
          : modulePath; // Avoid adding `/` if `url` is empty
        flatRoutes.push({
          ...subRoute,
          fullPath: subRoutePath,
          breadcrumbs: currentBreadcrumbs,
          moduleId: route.id, // Add moduleId
        });
      });
    }

    if (route.sections) {
      route.sections.forEach((section) => {
        const sectionPath = section.url
          ? `${modulePath}/${section.url}`
          : modulePath; // Avoid adding `/` if `url` is empty
        const sectionBreadcrumbs = [...currentBreadcrumbs, section.id]; // Use `id` instead of `title`

        if (section.subRoutes) {
          section.subRoutes.forEach((subRoute) => {
            const subRoutePath = subRoute.url
              ? `${sectionPath}/${subRoute.url}`
              : sectionPath; // Avoid adding `/` if `url` is empty
            flatRoutes.push({
              ...subRoute,
              fullPath: subRoutePath,
              breadcrumbs: sectionBreadcrumbs,
              moduleId: route.id, // Add moduleId
              sectionId: section.id, // Add sectionId
            });
          });
        } else {
          flatRoutes.push({
            ...section,
            fullPath: sectionPath,
            breadcrumbs: sectionBreadcrumbs,
            moduleId: route.id, // Add moduleId
          });
        }
      });
    }

    if (!route.subRoutes && !route.sections) {
      flatRoutes.push({
        ...route,
        fullPath: modulePath,
        breadcrumbs: currentBreadcrumbs,
        moduleId: route.id, // Add moduleId
      });
    }
  });

  return flatRoutes;
};

export const FACILITATOR_CERTIFICATE_ROUTE =
  '/facilitator/hybrid-ezparent-delivery/certificate';

export const flatFacilitatorRoutes = flattenRoutes(fascilitatorTrainingRoutes);
console.log(flatFacilitatorRoutes, 'flat');

export default fascilitatorTrainingRoutes;
